import {inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedelta-pos/data-client";

@Injectable({providedIn: "root"})
export class TableStatusManageRsaService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- TableStatusManageRsaService");

        super(http, nameSpace, "table-status-manage-rsa", configService, useAsync, actionNames);
    }
}
